import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import download from "../../../../assets/img/svg/DownloadIcon.svg";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import docIcon from "../../../../assets/img/svg/docIcon.svg"
import { TextField, Radio, RadioGroup, InputAdornment, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { Tabs, Tab, AppBar, Typography, Box, InputBase } from '@material-ui/core';
import PropTypes from 'prop-types';
import EditIR_Detail from './EditIR-Detail'
import EditIR_Historylog from './EditIR-Historylog'
import del from "../../../../assets/img/svg/Del.svg"
import { useNavigate } from "react-router-dom";
import deactive from '../../../../assets/img/svg/deactive.svg';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import IconButton from '@material-ui/core/IconButton';
import { getIR_ListView, deletemulitiirdocs, deleteIR } from "../../../../actions/InvestigationReportAction";
import axios from "axios";
import moment from "moment";
import { filedeleteDoc, filedeleteirPhoto } from "../../../../actions/InvestigationReportAction";
import API from "../../../../_helpers/endpointService";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InnerImageZoom from "react-inner-image-zoom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class EditIR extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.inputPhoto = React.createRef();
        this.state = {
            cancel: false,
            isMobile: false,
            value: 0,
            isView: false,
            isMore: false,
            DeleteData: [],
            files: [],
            photos: [],
            ViewDate: "",
            index: 0,
            ViewData: [],
            isError: false,
            radio: 'sample',
            filename: "",
            awsname: "",
            Id: 0,

            Error: {
                DateError: false,
                DescriptionError: false,
                IncidentTypeError: false,
                InvestigationTypeError: false,
            },
            DelIndex: 0,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Investigationtype": "",
                "Incidenttype": [],
                "Date": "",
                "Description": "",
                "Comments": "",
                "ModifiedBy": ""
            }
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.getSettingsFormat(parseInt(localStorage.getItem("DashId")))
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.addData.Id = parseInt(localStorage.getItem("IREditId"))
        let tempdata = {
            data: parseInt(localStorage.getItem("IREditId"))
        }
        this.state.DeleteData.push(tempdata)
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        window.location.pathname == '/investigationreports/edit' ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        if (window.location.pathname == "/investigationreports/view") {
            this.state.ViewDate = localStorage.getItem("IRViewId")
            this.setState({})
            this.ViewPage(this.state.ProjectId, this.state.ViewDate);
        } else {
            this.geteditirdocinfo(this.state.addData.Id)
        }
    }
    getSettingsFormat = (data) => {
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    ViewPage = (id, date) => {
        let apiUrl = API.IR_LISTVIEW + '/' + date;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.ViewData = response.data;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    geteditirdocinfo = (id) => {
        let apiUrl = API.IR_LISTVIEW + '/' + id;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Description = response.data.Description;
                    this.state.addData.Date = response.data?.Date;
                    this.state.addData.Incidenttype = response.data?.Incidenttype;
                    this.state.addData.Investigationtype = response.data?.Investigationtype;
                    this.state.addData.Comments = response.data?.Comments;
                    if (response.data?.Documents.length > 0) {
                        response.data?.Documents.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.files = response.data?.Documents;
                    }
                    if (response.data?.Photos.length > 0) {
                        response.data?.Photos.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.photos = response.data?.Photos;
                    }
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#INVES1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Investigation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Investigation").addClass("d-none");
        $("#Investigation").removeClass("d-block");
        $("#IRL").removeClass("active-color");
        $("#IRT").removeClass("fw-bolder");
    }
    UploadFile = (e) => {
        const { files } = this.state
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            this.state.files.push(upload)
            this.setState({})
        })
    };
    UploadPhoto = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
                FileUrl: await this.toBase64(a),
            }
            this.state.photos.push(upload)
            this.setState({})
        })

    };
    openView = (url, name, ind) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.state.index = ind;
        this.setState({})
        window.$('#viewscreen').modal('show')
    }
    openView1 = (url, name, ind) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.state.index = ind
        this.setState({})
        window.$('#viewscreen1').modal('show')
    }
    nextView = (ind) => {
        if (this.state.isView ? this.state.ViewData.Photos.length === ind : this.state.photos.length === ind) {
            this.setState({
                index: 0
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    preView = (ind) => {
        if (ind === -1) {
            this.setState({
                index: this.state.isView ? this.state.ViewData.Photos.length - 1 : this.state.photos.length - 1
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    setIndex = (ind) => {
        this.setState({
            index: ind
        })
    }
    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    OpenPopup1 = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup1").modal("show");
    }
    DeleteItem = () => {
        let tempData = [];
        this.state.files.map((i) => {
            if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeleteDoc(this.state.addData.Id, this.state.awsname))
                this.geteditirdocinfo(this.state.addData.Id)
            }
            if (i.FileName != this.state.filename) {
                tempData.push(i)
            }
        })
        this.state.files = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    DeleteItem1 = () => {
        let tempData = [];
        this.state.photos.map((i) => {
            if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeleteirPhoto(this.state.addData.Id, this.state.awsname))
                this.geteditirdocinfo(this.state.addData.Id)
            }
            if (i.FileName != this.state.filename) {
                tempData.push(i)
            }
        })
        this.state.photos = tempData;
        this.setState({})
        window.$("#deletepopup1").modal("hide");
        this.geteditirdocinfo(this.state.addData.Id)
    }
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    checkedcheckbox = (i) => {
        let check = this.state.addData.Incidenttype.filter(x => x == i)
        if (check.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    handleChangeValue = (event, newValue) => {
        this.setState({
            value: newValue,
        })
    };
    AttachFiles = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.inputFile.current.click();
    };
    AttachPhoto = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.inputPhoto.current.click();
    };

    handleInputChange = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (str === "Description") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.Description = e.target.value;
            }
        } else if (str === "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.Comments = e.target.value;
            }
        }
        else {
            this.state.addData[str] = e.target.value;
        }
        this.setState({})
        this.props.dispatch({ type: "SHARE_IRDATAS", data: this.state.addData })

    };
    handleChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.checked == false) {
            if (this.state.addData.Incidenttype.length > 0) {
                this.state.addData.Incidenttype.map((i, ind) => {
                    if (i == e.target.value) {
                        this.state.addData.Incidenttype.splice(ind, 1)
                        this.setState({})
                    }
                })
            }
        }
        else {
            this.state.addData.Incidenttype.push(e.target.value)
            this.setState({})
        }
    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        if (window.innerWidth < 412) {
            this.setState({
                isMore: true
            })
        }
        else {
            this.setState({
                isMore: false
            })
        }
        $("#INVES1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Investigation1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Investigation").removeClass("d-none");
        $("#Investigation").addClass("d-block");
        $("#IRL").addClass("active-color");
        $("#IRT").addClass("fw-bolder");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.setState({})
    };
    DeleteItemID = () => {
        this.state.addData.Id = parseInt(localStorage.getItem("IREditId"))
        this.deleteIR(this.state.addData.Id, this.state.UserRole)
    }
    deleteIR = (id, modify) => {
        const { dispatch } = this.props
        let apiUrl = API.IR_LISTVIEW + '/' + id + '?modify=' + modify;
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.navigate("/investigationreports")
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };
    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/investigationreports")
    };
    EditCancel1 = () => {
        if (this.state.value == 1) {
            this.state.value = 0
            this.setState({})
        }
        else {
            if (this.state.cancel == true) {
                window.$("#cancelpopup").modal("show");
            }
            else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate(`/investigationreports`)
            }
        }
    }
    ViewCancel = () => {
        this.props.navigate("/investigationreports")
    }
    EditSave = () => {
        if (this.state.addData.Date == "") {
            this.state.Error.DateError = true;
            this.setState({})

        }
        else {
            this.state.Error.DateError = false;
            this.setState({})
        }
        if (this.state.addData.Investigationtype == '') {
            this.state.Error.InvestigationTypeError = true;
            this.setState({})

        }
        else {
            this.state.Error.InvestigationTypeError = false;
            this.setState({})
        }
        if (this.state.addData.Incidenttype == "") {
            this.state.Error.IncidentTypeError = true;
            this.setState({})
        }
        else {
            this.state.Error.IncidentTypeError = false;
            this.setState({})
        }
        if (this.state.addData.Description == "") {
            this.state.Error.DescriptionError = true;
            this.setState({})
        }
        else {
            this.state.Error.DescriptionError = false;
            this.setState({})
        }
        if (this.state.addData.Date !== "" && this.state.addData.Incidenttype !== "" && this.state.addData.Investigationtype !== "" && this.state.addData.Description != "") {
            this.props.dispatch({ type: "CANCEL", data: false });
            let formData = new FormData()
            if (this.state.addData.Description.trim() != "") {
                this.state.addData.Description = this.state.addData.Description.trim();
                this.setState({})
            }
            else {
                this.state.addData.Description = this.state.addData.Description.trim();
                this.setState({})
            }
            if (this.state.addData.Comments != null) {
                this.state.addData.Comments = this.state.addData.Comments.trim();
                this.setState({})
            }
            Array.from(this.state.files).forEach(async (a) => {
                if (a.AwsUniqueFileName === undefined) {
                    formData.append("documents", a.fdata)
                }
            })
            Array.from(this.state.photos).forEach(async (a) => {
                if (a.AwsUniqueFileName === undefined) {
                    formData.append("photos", a.fdata)
                }
            })
            this.addIR(this.state.addData, formData, this.state.addData.Id,)
        }
        else {
        }
    }
    addIR = (data, formData, id) => {
        let apiUrl = API.IR_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.adduploadirdocinfo(formData, response.data)
                    //this.props.navigate("/investigationreports")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    }
    adduploadirdocinfo = (data, id) => {
        let Id = parseInt(localStorage.getItem("IREditId"));
        let apiUrl = API.IR_LISTVIEW + '/' + Id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/investigationreports")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"INVES" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="INVES" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>{this.state.isView ? "Investigation Report" : "Edit Investigation Report"}</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide ml-3" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {this.state.isView ? <> <td className="border-right " width="5%">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.ViewCancel}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </>
                                    : <>
                                        <td className="border-right text-center" width="5%">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i></td>
                                        {this.state.value == 1 ? <>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </> : <></>}
                                    </>}
                                {this.state.isView ? <></> :
                                    <>
                                        {this.state.value == 0 ? <>
                                            <td className="border-right text-center">
                                                <span className={classes.button} onClick={this.EditSave} style={{ minWidth: '60px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span>
                                            </td>
                                            <td className="border-right text-center">
                                                <span className={`${classes.button}`} onClick={this.EditCancel1} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                            </td>
                                            <td className="border-right text-center">
                                                <span className={`${classes.button}`} data-target="#deletepopup2" style={{ minWidth: '70px' }} data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span>
                                            </td>
                                        </> : <></>}
                                    </>
                                }
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        {this.state.isView ? <>
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.ViewCancel}></i>
                                        </> :
                                            <>
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i>
                                            </>}
                                    </td>
                                    <td width="95%">
                                        {this.state.isView ? <></> : <>
                                            {this.state.value == 0 ? <>
                                                <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.EditCancel1} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                                <button className={`${classes.button} pl-3`} data-target="#deletepopup2" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                            </> : <></>}
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 ml-2 mt-3">{this.state.isView ? "Investigation Report" : "Edit Investigation Report"}</h6>}
                        <div className="row">
                            <div >
                                {this.state.isView ?
                                    <>
                                    </> : <>
                                        <AppBar position="static" color="inherit" className={classes.root}>
                                            <Tabs
                                                value={this.state.value}
                                                onChange={this.handleChangeValue}
                                                classes={{ indicator: classes.indicator }}
                                            >
                                                <Tab label="Details" className="px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(0)} />
                                                <Tab label="History log" className="" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(1)} />
                                            </Tabs>
                                        </AppBar></>}

                                <TabPanel value={this.state.value} index={0}>
                                    <div>
                                        <div className={this.state.isMobile ? "row px-0 mt-n3" : "row px-2 mt-n3"}>
                                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : this.state.isView ? "col-md-2" : "col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "m-0 d-flex text-right float-end"}>Investigation Type&nbsp;:
                                                        {this.state.isView ? <></> : <>
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></>}
                                                    </label>
                                                </div>
                                                {this.state.isView ?
                                                    <div className={`col-12 col-sm-12 col-xl-7  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 col-lg-12 pt-1 pb-2" : "col-lg-10 col-md-10 pt-4 pb-3"}`}>
                                                        <RadioGroup row aria-label="gender" value={this.state.ViewData.Investigationtype} disabled fullWidth>
                                                            <FormControlLabel value="NearMiss" control={<Radio color="default" />} label="Near Miss" size="small" />
                                                            <FormControlLabel value="Incident" control={<Radio color="default" />} label="Incident" size="small" />
                                                        </RadioGroup>
                                                    </div>
                                                    :
                                                    <div className={`col-12 col-sm-12 col-xl-7  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 col-lg-12 pt-1 pb-2" : "col-lg-10 col-md-10 pt-4 pb-3"}`}>
                                                        {this.state.Error.Investigationtype ?
                                                            <>
                                                                <RadioGroup row aria-label="gender" value={this.state.addData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth className={classes.error}>
                                                                    <FormControlLabel value="NearMiss" control={<Radio color="default" className={classes.error} />} label="Near Miss" size="small" />
                                                                    <FormControlLabel value="Incident" control={<Radio color="default" className={classes.error} />} label="Incident" size="small" />
                                                                </RadioGroup>
                                                            </>
                                                            :
                                                            <RadioGroup row aria-label="gender" value={this.state.addData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth>
                                                                <FormControlLabel value="NearMiss" control={<Radio color="default" />} label="Near Miss" size="small" />
                                                                <FormControlLabel value="Incident" control={<Radio color="default" />} label="Incident" size="small" />
                                                            </RadioGroup>
                                                        }
                                                    </div>
                                                }

                                            </div>
                                            <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right  col-md-12" : this.state.isView ? "col-md-2" : "col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "m-0 d-flex text-right float-end"}>Date&nbsp;:
                                                        {this.state.isView ? <></> : <>
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></>}
                                                    </label>
                                                </div>
                                                {this.state.isView ?
                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        <TextField
                                                            type="date"
                                                            id="type-date"
                                                            disabled
                                                            value={this.state.ViewData.Date && moment(this.state.ViewData.Date).format("yyyy-MM-DD")}

                                                            placeholder={this.state.ViewData.Date && moment(this.state.ViewData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            InputProps={{
                                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                    </div>
                                                    :
                                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                        {this.state.Error.DateError ?
                                                            <TextField
                                                                type="date"
                                                                id="type-date"
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                                placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                onChange={(e) => { this.handleInputChange(e, "Date") }}
                                                                error
                                                                InputProps={{
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                                inputProps={{
                                                                    max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                    min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                                  }}
                                                            />
                                                            :
                                                            <TextField
                                                                type="date"
                                                                id="type-date"
                                                                value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                                placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                                onChange={(e) => { this.handleInputChange(e, "Date") }}
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                InputProps={{
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                                inputProps={{
                                                                    max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                    min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                                  }}
                                                            />
                                                        }
                                                    </div>}
                                            </div>
                                            <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : this.state.isView ? "col-md-2" : "col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "mt-2 d-flex text-right float-end"}>Incident Type&nbsp;:
                                                        {this.state.isView ? <></> : <>
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></>}
                                                    </label>
                                                </div>
                                                {this.state.isView ? <>
                                                    <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                        <div className="row">
                                                            {this.state.ViewData.Incidenttype && this.state.ViewData.Incidenttype.map((i, index) => (
                                                                <>
                                                                    <div className="pb-4 col-sm-6 col-12 col-md-4 col-lg-3 col-xl-3 d-flex">
                                                                        <label class="contCheck">
                                                                            <input type="checkbox" checked="true" ></input>
                                                                            <span class="checkmark view-color"></span>
                                                                        </label>
                                                                        <div className="ml-5">{i}</div>
                                                                    </div>
                                                                </>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </>
                                                    :
                                                    <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                        {this.state.Error.IncidentTypeError ?
                                                            <div className="row " style={{}}>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Fatalities" checked={this.checkedcheckbox("Fatalities")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>Fatalities</div>
                                                                </div>
                                                                <div className=" pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="LTI" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>LTI</div>
                                                                </div>
                                                                <div className=" pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="RWC" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>RWC</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="FAC" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>FAC</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="MTC" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>MTC</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Property Damage" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>Property Damage</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Oil Spill" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>Oil Spill</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Chemical Spill" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>Chemical Spill</div>
                                                                </div>
                                                                <div className=" pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Gas Leakage" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>Gas Leakage</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Environmental Damage" onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                    <div className={`${classes.error} ml-5`}>Environmental Damage</div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="row " style={{}}>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Fatalities" checked={this.checkedcheckbox("Fatalities")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">Fatalities</div>
                                                                </div>
                                                                <div className=" pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="LTI" checked={this.checkedcheckbox("LTI")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">LTI</div>
                                                                </div>
                                                                <div className=" pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="RWC" checked={this.checkedcheckbox("RWC")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">RWC</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="FAC" checked={this.checkedcheckbox("FAC")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">FAC</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="MTC" checked={this.checkedcheckbox("MTC")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">MTC</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Property Damage" checked={this.checkedcheckbox("Property Damage")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">Property Damage</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Oil Spill" checked={this.checkedcheckbox("Oil Spill")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">Oil Spill</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Chemical Spill" checked={this.checkedcheckbox("Chemical Spill")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">Chemical Spill</div>
                                                                </div>
                                                                <div className=" pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Gas Leakage" checked={this.checkedcheckbox("Gas Leakage")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">Gas Leakage</div>
                                                                </div>
                                                                <div className="pb-4 col-sm-3 d-flex">
                                                                    <label class="contCheck">
                                                                        <input type="checkbox" value="Environmental Damage" checked={this.checkedcheckbox("Environmental Damage")} onChange={(e) => this.handleChange(e)}></input>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <div className="ml-5">Environmental Damage</div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>}
                                            </div>

                                            {this.state.isView ?
                                                this.state.ViewData.Description === "" || this.state.ViewData.Description === null ? <></> : <>
                                                    <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                                            <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end"}>Description&nbsp;:</label>
                                                        </div>
                                                        <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-10 pt-4 pb-4"}`}>
                                                            <TextField
                                                                variant="outlined"
                                                                multiline
                                                                rows={4}
                                                                disabled
                                                                size="small"
                                                                fullWidth
                                                                value={this.state.ViewData.Description}
                                                                InputProps={{
                                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <div className={`row mx-1 align-items-center  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 px-0"}`}>
                                                        <label className={this.state.isMobile ? "d-flex pt-2" : "m-0 d-flex text-right float-end "}>Description&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label>
                                                    </div>
                                                    <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                        {this.state.Error.DescriptionError ?
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                error
                                                                multiline
                                                                value={this.state.addData.Description}
                                                                onChange={(e) => { this.handleInputChange(e, "Description") }}
                                                                rows={4}
                                                                InputProps={{
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                            :
                                                            <TextField
                                                                variant="outlined"
                                                                multiline
                                                                rows={4}
                                                                size="small"
                                                                fullWidth
                                                                value={this.state.addData.Description}
                                                                onChange={(e) => { this.handleInputChange(e, "Description") }}
                                                                InputProps={{
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                            />}
                                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Description?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Description?.length}/500 Characters left</label>
                                                    </div>
                                                </div>
                                            }


                                            {this.state.isView ? this.state.ViewData.Documents === null ? <></> :
                                                <>
                                                    <div className={`row mx-1  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                                            <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end pt-3 mt-2"}>Documents&nbsp;:</label>
                                                        </div>
                                                        {/* <div className={`col-12 col-sm-12  col-md-10 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom" : "pt-3 col-md-2"}`}>

                                                            <div className="row px-1">
                                                                {this.state.ViewData.Documents && this.state.ViewData.Documents.map((a) => (
                                                                    <div className={`col-10 col-sm-4 col-lg-3 col-xl-2 align-items-center   px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                                        <div className="row d-flex">
                                                                            <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9 ">
                                                                                <label className=" pt-2 word-break">{a.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(a.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div> */}
                                                        <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2 col-md-10"}`}>
                                                            <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                                {this.state.ViewData.Documents && this.state.ViewData.Documents.map((a) => (
                                                                    <div className={`col-6 col-lg-3 col-xl-2 align-items-center border-right  px-2 mt-1 mb-2 ${window.innerWidth < 360 ? "col-12" : this.state.isMobile ? "col-md-3 col-sm-3" : "col-md-4 col-sm-4"}`}>
                                                                        <div className="row d-flex pr-3">
                                                                            <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12">
                                                                                <div className="pt-2 overflow"><a href={a.FileUrl} style={{ color: "#000000" }} target="_blank">{a.FileName}</a><br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(a.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                : <>
                                                    <div className={`row mx-1  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                                            <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end pt-3 mt-2"}>Documents&nbsp;:</label>
                                                        </div>
                                                        <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1" : "col-md-4 pt-4 pb-3"}`}>
                                                            <TextField
                                                                disabled
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                accept=".pdf"
                                                                onChange={(e) => { this.UploadFile(e) }}
                                                                placeholder="Browse File"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment className="mr-0">
                                                                            <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                                <AttachFileIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                            <input
                                                                hidden
                                                                type="file"
                                                                multiple="multiple"
                                                                accept=".pdf"
                                                                onChange={(e) => { this.UploadFile(e) }}
                                                                ref={this.inputFile}
                                                            />
                                                        </div>
                                                        {/* <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                            <div className="row px-1">
                                                                {this.state.files && this.state.files.map((m, i) => (
                                                                    <div className={`col-10 col-sm-6 col-lg-4 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-6 " : "col-md-6 "}`}>
                                                                        <div className="row d-flex">
                                                                            <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10 ">
                                                                                <label className=" pt-2 word-break">{m.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(m.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                                                            </div>
                                                                            <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 px-1 mt-2 pt-1">
                                                                                <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(m.FileName, m.AwsUniqueFileName, m.Id) }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                                )}
                                                            </div>
                                                        </div> */}
                                                        <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                            <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                                {this.state.files && this.state.files.map((m, i) => (

                                                                    <div className={`col-6 col-lg-4 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 360 ? "col-12" : this.state.isMobile ? "col-md-4 col-sm-4" : "col-md-6 col-sm-6"}`}>
                                                                        <div className="row d-flex pr-3">
                                                                            <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                                                <div className="pt-2 overflow">{m.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(m.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                            </div>
                                                                            <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pl-1 pr-2 mt-2 pt-1">
                                                                                <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(m.FileName, m.AwsUniqueFileName, m.Id) }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }


                                            {this.state.isView ? this.state.ViewData.Photos === null ? <></> :
                                                <>
                                                    <div className={`row mx-1  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                                            <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end pt-3 mt-2"}>Photos&nbsp;:</label>
                                                        </div>
                                                        <div
                                                            className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                                    ? "border-left border-right border-bottom"
                                                                    : "pt-1 col-md-10 "
                                                                }`}
                                                        >
                                                            <div className="row px-1">
                                                                {this.state.ViewData.Photos &&
                                                                    this.state.ViewData.Photos.map((i, ind) => (
                                                                        <div
                                                                            className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center  px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                                    ? "col-12"
                                                                                    : this.state.isMobile
                                                                                        ? "col-md-4 "
                                                                                        : "col-md-4"
                                                                                }`}
                                                                        >
                                                                            <div className="row d-flex">
                                                                                <div
                                                                                    className={`${window.innerWidth < 290
                                                                                            ? ""
                                                                                            : "col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3"
                                                                                        }`}
                                                                                    onClick={() => {
                                                                                        this.openView1(
                                                                                            i.FileUrl,
                                                                                            i.FileName,
                                                                                            ind
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        className="cursorPointer"
                                                                                        width={
                                                                                            window.innerWidth < 290
                                                                                                ? "100%"
                                                                                                : "257px"
                                                                                        }
                                                                                        src={i.FileUrl}
                                                                                        onClick={() => {
                                                                                            this.openView1(
                                                                                                i.FileUrl,
                                                                                                i.FileName,
                                                                                                ind
                                                                                            );
                                                                                        }}
                                                                                        style={{
                                                                                            height: "201px",
                                                                                            marginTop: "-9px",
                                                                                            objectPosition: "50% 50%",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                        {/* <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom" : "pb-1 col-md-10"}`}>
                                                            <div className="row px-1">
                                                                {this.state.ViewData.Photos && this.state.ViewData.Photos.map((i, ind) => (
                                                                    <div className={`col-6 col-sm-4 col-lg-3 col-xl-2 align-items-center border-right px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-4"}`}>
                                                                        <div className="row d-flex">
                                                                            <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }}>
                                                                                <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                            </div>
                                                                            <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                                                <div className="cursorPointer pt-2 ml-3 overflow" onClick={() => { this.openView1(i.FileUrl, i.FileName, ind) }}>{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}

                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className={`row mx-1  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                                            <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end pt-3 mt-2"}>Photos&nbsp;:</label>
                                                        </div>
                                                        <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right   col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                                            <TextField
                                                                disabled
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                placeholder="Browse File"
                                                                onChange={(e) => this.UploadPhoto(e)}
                                                                accept=".png,.jpg"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment style={{ marginRight: 0 }}>
                                                                            <IconButton className="rotate p-0" onClick={this.AttachPhoto}>
                                                                                <AttachFileIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                            <input
                                                                hidden
                                                                type="file"
                                                                multiple="multiple"
                                                                onChange={(e) => this.UploadPhoto(e)}
                                                                accept=".png,.jpg"
                                                                ref={this.inputPhoto}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                                                        <div className="row mx-0 px-0">
                                                            <div
                                                                className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                                        ? "border-left border-right border-bottom col-md-12"
                                                                        : "mt-2"
                                                                    }`}
                                                            >
                                                                <div
                                                                    className={
                                                                        this.state.isMobile
                                                                            ? "row pl-2 pr-3"
                                                                            : "row px-1"
                                                                    }
                                                                >
                                                                    {this.state.photos &&
                                                                        this.state.photos.map((i, ind) => {
                                                                            return (
                                                                                <div
                                                                                    className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                                            ? "col-12"
                                                                                            : this.state.isMobile
                                                                                                ? "col-md-4 "
                                                                                                : "col-md-6"
                                                                                        }`}
                                                                                >
                                                                                    <div className="row d-flex">
                                                                                        <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                                                                        <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3">
                                                                                            <img
                                                                                                src={Delete}
                                                                                                className="cursorPointer"
                                                                                                onClick={() => { this.OpenPopup1(i.FileName, i.AwsUniqueFileName, i.Id, i) }}
                                                                                            />
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2"
                                                                                            onClick={() => {
                                                                                                this.openView(
                                                                                                    i.FileUrl,
                                                                                                    i.FileName,
                                                                                                    ind
                                                                                                );
                                                                                            }}
                                                                                        >
                                                                                            <img
                                                                                                src={i.FileUrl}
                                                                                                className="cursorPointer"
                                                                                                width={
                                                                                                    window.innerWidth < 290
                                                                                                        ? "100%"
                                                                                                        : "257px"
                                                                                                }
                                                                                                onClick={() => {
                                                                                                    this.openView(
                                                                                                        i.FileUrl,
                                                                                                        i.FileName,
                                                                                                        ind
                                                                                                    );
                                                                                                }}
                                                                                                style={{
                                                                                                    height: "201px",
                                                                                                    marginTop: "-9px",
                                                                                                    objectPosition: "50% 50%",
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className={`col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                            <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                                {this.state.photos && this.state.photos.map((i, ind) => (
                                                                    <div className={`col-6 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                                        <div className="row d-flex">
                                                                            <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}>
                                                                                <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                            </div>
                                                                            <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                                                <div onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} className="cursorPointer pt-2 ml-3 overflow">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                            </div>
                                                                            <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 pr-2 mt-2 pt-2">
                                                                                <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup1(i.FileName, i.AwsUniqueFileName, i.Id, i) }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </>
                                            }
                                            {this.state.isView ? <></> : <>
                                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>


                                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                                        <label className={this.state.isMobile ? " pt-2" : "m-0 d-flex text-right float-end"}>Comments&nbsp;:</label>
                                                    </div>
                                                    <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                        <TextField
                                                            multiline
                                                            rows={8}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            value={this.state.addData.Comments}
                                                            onChange={(e) => { this.handleInputChange(e, "Comments") }}

                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                                    </div>


                                                </div>
                                            </>
                                            }

                                        </div>
                                        <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                                            <div class="modal-dialog" role="document">
                                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                                    <div class="modal-body pb-0">
                                                        <h1 className="text-center">
                                                            <img src={del}></img>
                                                        </h1>
                                                        <div className="text-center">
                                                            <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                                    </div>
                                                    <div class="modal-footer border-top-0 m-auto">
                                                        <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                                        <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                                            <div class="modal-dialog" role="document">
                                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                                    <div class="modal-body pb-0">
                                                        <h1 className="text-center">
                                                            <img src={del}></img>
                                                        </h1>
                                                        <div className="text-center">
                                                            <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                                    </div>
                                                    <div class="modal-footer border-top-0 m-auto">
                                                        <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                                        <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                                            <div class="modal-dialog" role="document">
                                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                                    <div class="modal-body pb-0">
                                                        <h1 className="text-center">
                                                            <img src={del}></img>
                                                        </h1>
                                                        <div className="text-center">
                                                            <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                                    </div>
                                                    <div class="modal-footer border-top-0 m-auto">
                                                        <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem1()}><span className="" >Delete</span></button>
                                                        <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <EditIR_Historylog />
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup2" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>  </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItemID}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal3" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade " id="viewscreen1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end mr-3' id="viewscreen1" onClick={() => {
                                                window.$('#viewscreen1').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                <div class="carousel-indicators">

                                                </div>

                                                <div class="carousel-inner" >
                                                    {this.state.ViewData.Photos && this.state.ViewData.Photos.map((i, ind) => (<>

                                                        <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                            <div>
                                                                <InnerImageZoom
                                                                    moveType="drag"
                                                                    zoomScale={2}
                                                                    hideCloseButton={true}
                                                                    src={i.FileUrl}
                                                                    hasSpacer={true}
                                                                    afterZoomIn={() => { $('#viewscreen1 > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                    afterZoomOut={() => { $('#viewscreen1 > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                />
                                                            </div>
                                                            {this.state.ViewData.Photos.length <= 1 ? "" : <>
                                                                <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                    <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Previous</span>
                                                                </button>
                                                                <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Next</span>
                                                                </button>
                                                            </>}

                                                        </div>
                                                    </>))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end mr-3 hidefield' id="viewscreen" onClick={() => {
                                                window.$('#viewscreen').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                <div class="carousel-indicators">

                                                </div>
                                                <div class="carousel-inner" >
                                                    {this.state.photos && this.state.photos.map((i, ind) => (<>
                                                        <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                            <div>
                                                                <InnerImageZoom
                                                                    moveType="drag"
                                                                    zoomScale={2}
                                                                    hideCloseButton={true}
                                                                    src={i.FileUrl}
                                                                    hasSpacer={true}
                                                                    afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                    afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                />
                                                            </div>
                                                            {this.state.photos.length <= 1 ? "" : <>
                                                                <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                    <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Previous</span>
                                                                </button>
                                                                <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Next</span>
                                                                </button>
                                                            </>}
                                                        </div>
                                                    </>))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        geteditir: state.IRReducer.geteditir || [],
        settings: state.commonReducer.settings || [],
        sharedirattachfile: state.IRReducer.sharedirattachfile || [],
        sharedirattachphoto: state.IRReducer.sharedirattachphoto || [],
        sharedirdata: state.IRReducer.sharedirdata || [],
        errorirpass: state.IRReducer.errorirpass || [],
    };
}

EditIR.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditIR))
);
